import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // Add Functions import

const firebaseConfig = {
  apiKey: "AIzaSyCzw99VXJFchJ444GZKB3imCa_pwJnA0m8",
  authDomain: "rsvp-system-915fb.firebaseapp.com",
  projectId: "rsvp-system-915fb",
  storageBucket: "rsvp-system-915fb.firebasestorage.app",
  messagingSenderId: "913654975965",
  appId: "1:913654975965:web:e025959afbe25fdfc57a34"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app); // Initialize Functions

export { auth, db, storage, functions }; // Export functions
